export interface CountInBeat {
  remaining: number;
  accent: boolean;
  spokenCount: number;
}

type CountInTimer = number | ReturnType<typeof setTimeout>;

export interface CountInOptions {
  beatsPerBar: number;
  bpm: number;
  tempoScale: number;
  onCount: (remaining: number) => void;
  onBeat: (beat: CountInBeat) => void;
  onComplete: () => void;
  schedule?: (callback: () => void, delayMs: number) => CountInTimer;
  clear?: (timer: CountInTimer) => void;
}

export interface CountInHandle {
  cancel: () => void;
  isActive: () => boolean;
}

export function startCountIn(options: CountInOptions): CountInHandle {
  const schedule = options.schedule ?? setTimeout;
  const clear = options.clear ?? clearTimeout;
  const beatMs = 60_000 / (options.bpm * options.tempoScale);
  let timer: CountInTimer | null = null;
  let remaining = options.beatsPerBar;
  let active = true;

  const cancel = (): void => {
    active = false;
    if (timer !== null) {
      clear(timer);
      timer = null;
    }
    options.onCount(0);
  };

  const tick = (): void => {
    timer = null;
    if (!active) return;
    remaining -= 1;
    if (remaining <= 0) {
      active = false;
      options.onCount(0);
      options.onComplete();
      return;
    }
    options.onCount(remaining);
    options.onBeat({
      remaining,
      accent: remaining === options.beatsPerBar,
      spokenCount: options.beatsPerBar - remaining + 1,
    });
    timer = schedule(tick, beatMs);
  };

  options.onCount(remaining);
  options.onBeat({ remaining, accent: true, spokenCount: 1 });
  timer = schedule(tick, beatMs);

  return {
    cancel,
    isActive: () => active,
  };
}
